// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__3hjt6"};